class CheckMySite {

  private static instance: CheckMySite;
  private revenueData: RevenueData;
  private urlElement: HTMLInputElement;
  private urlError: HTMLElement;
  private speedElement: HTMLInputElement;
  private speedLegendElement: HTMLSpanElement;
  private visitorsElement: HTMLInputElement;
  private orderValueElement: HTMLInputElement;
  private conversionElement: HTMLInputElement;
  private impactSliderElement: HTMLInputElement;
  private impactSliderProgressIndicator: SVGPathElement;
  private impactOutputElement: HTMLOutputElement;
  private speedOutputElement: HTMLOutputElement;
  private impactResultElement: HTMLParagraphElement;
  private cmsButtonElement: HTMLButtonElement;
  private cmsFakeButtonElement: HTMLDivElement;

  private constructor() {
  }

  public static getInstance(): CheckMySite {
    if (!CheckMySite.instance) {
      CheckMySite.instance = new CheckMySite();
    }

    return CheckMySite.instance;
  }

  public initialize() {
    const checkmysite = CheckMySite.getInstance();
    this.urlElement = document.querySelector('#cms_url');
    this.urlError = document.querySelector('.crftd-cms__field--url > span.crftd-error');
    this.cmsButtonElement = document.querySelector('#cms_url_button');
    this.cmsFakeButtonElement = document.querySelector('#cms_url_fake_button');
    this.speedElement = document.querySelector('#cms_speed');
    this.speedLegendElement = document.querySelector('#cms_speed-improvement-legend__current-speed');
    this.visitorsElement = document.querySelector('#cms_visitors');
    this.orderValueElement = document.querySelector('#cms_value');
    this.conversionElement = document.querySelector('#cms_conversion');
    this.impactSliderElement = document.querySelector('#cms_speed-improvement-slider');
    this.impactSliderProgressIndicator = document.querySelector('.cms_speed-improvement-progress__line');
    this.impactOutputElement = document.querySelector('#output_revenue');
    this.speedOutputElement = document.querySelector('#output_speed');
    this.impactResultElement = document.querySelector('.crftd-cms-result__revenue');

    fetch("/wp-content/themes/crafted-child/assets/js/revenue-rearranged.min.json")
      .then(response => response.json())
      .then(json => this.revenueData = json);

    if (this.urlElement) {
      this.urlElement.addEventListener('keydown', event => {
        if (event.isComposing || event.keyCode === 13) {
          checkmysite.testURL(event);
        }
      }, {passive: true});
    }

    if (this.cmsButtonElement) {
      this.cmsButtonElement.addEventListener('click', checkmysite.testURL, {passive: true});
    }

    if (this.speedElement) {
      this.speedElement.addEventListener('input', checkmysite.calculateImpact, {passive: true});
    }

    if (this.visitorsElement) {
      this.visitorsElement.addEventListener('input', checkmysite.calculateImpact, {passive: true});
    }

    if (this.orderValueElement) {
      this.orderValueElement.addEventListener('input', checkmysite.calculateImpact, {passive: true});
    }

    if (this.conversionElement) {
      this.conversionElement.addEventListener('input', checkmysite.calculateImpact, {passive: true});
    }

    if (this.impactSliderElement) {
      this.impactSliderElement.addEventListener('input', checkmysite.calculateImpact, {passive: true});
    }

  }

  public static setUpQuery(url: string): string {
    const api = 'https://www.googleapis.com/pagespeedonline/v5/runPagespeed';
    const parameters: APIParameters = {
      url: encodeURIComponent(url),
      key: 'AIzaSyDdpz1cUhzf6W-oxLI7he9TPTPTZDMgvAY'
    };
    let query: string = `${api}?`;
    query += `url=${parameters.url}`;
    query += `&strategy=mobile`;
    query += `&category=performance`;
    query += `&key=${parameters.key}`;

    return query;
  }

  public testURL(event: Event): void {
    const checkmysite = CheckMySite.getInstance();
    const url = CheckMySite.setUpQuery(checkmysite.urlElement.value);
    const buttonElement = checkmysite.cmsButtonElement;
    const fakeButtonElement = checkmysite.cmsFakeButtonElement;
    const urlElement = checkmysite.urlElement;
    const speedElement = checkmysite.speedElement;
    var speedIndex: number;

    if (checkmysite.urlElement.checkValidity()) {
      checkmysite.urlError.textContent = ``;
      requestAnimationFrame(() => {
        buttonElement.setAttribute('disabled', 'disabled');
        buttonElement.children[0].textContent = `Checking speed...`;
        fakeButtonElement.classList.add('state-loading');
        urlElement.setAttribute('disabled', 'disabled');
      });
      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response.json();
        })
        .then(json => {
          // See https://developers.google.com/speed/docs/insights/v5/reference/pagespeedapi/runpagespeed#response
          // json.originLoadingExperience ... Felddaten
          // json.loadingExperience ... Labdaten
          requestAnimationFrame(() => {
            fakeButtonElement.classList.remove('state-loading');
            setTimeout(() => {
              fakeButtonElement.classList.add('state-loading--finished');
              speedIndex = json['lighthouseResult']['audits']['speed-index']['numericValue'];
              speedElement.value = (Math.round((speedIndex / 100 + Number.EPSILON)) / 10).toString();
              let event: Event = new Event('input', {
                bubbles: true,
                cancelable: true,
              });
              speedElement.dispatchEvent(event);
              speedElement.focus();
            }, 1);
            setTimeout(() => {
              requestAnimationFrame(() => {
                buttonElement.children[0].textContent = `Check speed`;
                fakeButtonElement.classList.add('state-loading--reset');
                setTimeout(() => {
                  fakeButtonElement.classList.remove('state-loading--reset')
                }, 1);
                fakeButtonElement.classList.remove('state-loading--finished');
                buttonElement.removeAttribute('disabled');
                urlElement.removeAttribute('disabled');
              });
            }, 7000);
          });

        }).catch(function (error) {
        console.log(error);
      });
    } else {
      checkmysite.urlError.textContent = `No valid URL given`;
    }
  }

  public calculateImpact(event: Event): void {
    const checkmysite = CheckMySite.getInstance();
    let allValid = true;
    let sliderValue:number;

    if (checkmysite.visitorsElement.value === "" || !checkmysite.visitorsElement.checkValidity()) {
      allValid = false;
    }
    if (checkmysite.orderValueElement.value === "" || !checkmysite.orderValueElement.checkValidity()) {

      allValid = false;
    }
    if (checkmysite.conversionElement.value === "" || !checkmysite.conversionElement.checkValidity()) {
      allValid = false;
    }

    if (checkmysite.speedElement.value === "" || !checkmysite.speedElement.checkValidity()) {
      checkmysite.speedLegendElement.textContent = `-`;
      allValid = false;
    } else {
      checkmysite.impactSliderElement.max = (parseFloat(checkmysite.speedElement.value) - 1).toString();
      checkmysite.impactSliderElement.value = (Math.min(parseFloat(checkmysite.impactSliderElement.value), parseFloat(checkmysite.speedElement.value))).toString();
      checkmysite.speedLegendElement.textContent = checkmysite.speedElement.value;

      // const scale:number = (sliderValue - 1) / (parseFloat(checkmysite.impactSliderElement.max));
      // sliderValue = (Math.min(1, parseFloat(checkmysite.speedElement.value)));
      if (!allValid) {
        CheckMySite.resetResults();
      }
    }

    if (!allValid) {
      checkmysite.impactSliderElement.disabled = true;
      checkmysite.impactOutputElement.textContent = `-`;
      checkmysite.impactResultElement.classList.remove('crftd-cms-result__revenue--success');
      return;
    }
    checkmysite.impactResultElement.classList.add('crftd-cms-result__revenue--success');
    checkmysite.impactSliderElement.disabled = false;

    const speed: number = checkmysite.speedElement.valueAsNumber;
    // const speedImprovement: number = (parseFloat(checkmysite.impactSliderElement.max) * 10 - checkmysite.impactSliderElement.valueAsNumber * 10) / 10;
    const speedImprovement: number = checkmysite.impactSliderElement.valueAsNumber;
    const visitors: number = checkmysite.visitorsElement.valueAsNumber;
    const orderValue: number = checkmysite.orderValueElement.valueAsNumber;
    const conversionRate: number = checkmysite.conversionElement.valueAsNumber / 100;
    const scale:number = (parseFloat(checkmysite.impactSliderElement.value)) / (parseFloat(checkmysite.impactSliderElement.max));
    checkmysite.impactSliderProgressIndicator.style.transform = `scaleX(${scale})`;

    if (speedImprovement === 0) {
      checkmysite.impactOutputElement.textContent = `0`;
      return;
    }
    checkmysite.impactOutputElement.textContent = speedImprovement.toLocaleString(
      undefined,
      {minimumFractionDigits: 1, maximumFractionDigits: 1}
    );

    let newConversionRate: number;
    let impact: number;

    newConversionRate = CheckMySite.calculateNewConversionRate(speed, speedImprovement, conversionRate);

    impact = Math.round(visitors * orderValue * newConversionRate * 12 + Number.EPSILON);

    checkmysite.impactOutputElement.textContent = impact.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  private static resetResults(): void {
    const checkmysite = CheckMySite.getInstance();

    checkmysite.impactSliderElement.value = checkmysite.impactSliderElement.min.toString();
    checkmysite.speedOutputElement.textContent = `0`;
    checkmysite.impactSliderProgressIndicator.style.transform = `scaleX(0)`;
  }

  private static calculateNewConversionRate(speed: number, speedImprovement: number, conversionRate: number): number {
    let newConversionRate: number = 0;
    let dropData: number;
    let newDrop: number;
    const steps: number = speedImprovement * 10;
    const checkmysite = CheckMySite.getInstance();

    if (steps === 1) {
      return 0;
    }
    newDrop = conversionRate;
    dropData = 1;

    for (let n = 0; n < steps; n++) {
      let index = (((speed * 10) - n) / 10).toString();

      if (n > 0) {
        newDrop = newDrop / (1 - (0.01 * dropData));
      }
      dropData = checkmysite.revenueData[index];
    }

    newConversionRate = newDrop - conversionRate;

    return newConversionRate;
  }
}

export default CheckMySite.getInstance();
